import { Navigate } from 'react-router-dom';
import { useAuth } from '../../features/auth/hooks/useAuth';
import { PageLoader } from '../../layouts/components/PageLoader/PageLoader';
import { routes } from '../routes';

export const PublicGuard = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <PageLoader />;
  }

  if (isAuthenticated) {
    return <Navigate to={routes.wizard.base} replace />;
  } else {
    return <Navigate to={routes.public.signup} replace />;
  }
};
